import { delay } from 'redux-saga';
import { call, take, put, select } from 'redux-saga/effects';
import * as actions from 'actions/user';
import { SSO_SESSION_ACTIVE } from 'actions/auth';
import { setPartnerId, fetchPartnerIdFailed } from 'actions/analytics';
import { getUserInfo, getUserGroups, getUserData, getGAPartnerUserId } from 'api/user';
import { getAccount } from 'api/account';
import debug from 'debug';
import { getAuth } from 'selectors/auth';
import { setStorage } from 'utils/storageHelpers';

const log = debug('sagas:user');

export const WHITELIST_STORAGE_KEY = 'adgen-whitelisted';

export function* fetchUserInfo(windowObj = window, retryTimes = 5) {
  const { accessToken } = yield take(SSO_SESSION_ACTIVE);
  let error;

  for (let i = 0; i < retryTimes; i++) {
    try {
      log('fetching user info and groups');

      const [userInfo, groups, userData, account] = yield [
        call(getUserInfo, accessToken),
        call(getUserGroups, accessToken),
        call(getUserData, accessToken),
        call(getAccount, accessToken),
      ];

      log('finished fetching user info');

      const consolidatedInfo = {
        ...userInfo,
        groups,
        email: userData.email || '',
        account,
      };

      log('generated user info data: ', consolidatedInfo);

      yield put(actions.receiveUserInfo(consolidatedInfo));
      const { isWhitelisted } = yield select(getAuth);
      log('is user whitelisted? ' + isWhitelisted);
      yield call(setStorage, window.localStorage, WHITELIST_STORAGE_KEY, isWhitelisted);
      return;
    } catch (e) {
      log('error retrieving user info: ' + e.message);
      if (i < retryTimes) {
        error = e;
        log('delaying then retrying');
        yield call(delay, 2000);
      }
    }
  }

  log('could not fetch user info');
  windowObj.Raven.captureException(error);
}

export function* fetchPartnerId() {
  const { accessToken } = yield take(SSO_SESSION_ACTIVE);

  try {
    const partnerId = yield call(getGAPartnerUserId, accessToken);
    yield put(setPartnerId({ partnerId }));
  } catch (e) {
    log('Failed to fetch partner id', e);
    yield put(fetchPartnerIdFailed(e));
  }
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/user.js